import * as Constants from "../../utils/constants";

export const profileImageSet = (data: any) => {
  return {
    type: Constants.PROFILE_IMAGE_SET,
    payload: data,
  };
};
export const ManageCard = () => ({
  type: Constants.MANAGE_CARD_DATA,
});
export const GetManageCardData = (data: any) => ({
  type: Constants.GET_MANAGE_CARD_DATA,
  payload: data,
});

export const getMembersList = (payload: any) => ({
  type: Constants.GET_MANAGE_USERS_LIST,
  payload,
});

export const membersListSuccess = (payload: any) => ({
  type: Constants.MANAGE_USERS_LIST_SUCCESS,
  payload,
});

export const setSelectedUser = (payload: any) => ({
  type: Constants.MANAGE_USER_SELECTED,
  payload,
});

export const setFilter = (payload: any) => ({
  type: Constants.MANAGE_USER_FILTER,
  payload,
});

export const validateUser = (payload: any) => ({
  type: Constants.MANAGE_USER_VALIDATE,
  payload,
});

export const validateUserReset = () => ({
  type: Constants.MANAGE_USER_VALIDATE_RESET,
});

export const validateUserStatus = (payload: any) => ({
  type: Constants.MANAGE_USER_VALIDATE_STATUS,
  payload,
});

export const transferUser = (payload: any) => ({
  type: Constants.MANAGE_USER_TRANSFER,
  payload,
});

export const transferRequest = (payload: any) => ({
  type: Constants.MANAGE_USER_TRANSFER_REQUEST,
  payload,
});

export const confirmTransferRequest = (payload: any) => ({
  type: Constants.MANAGE_USER_TRANSFER_COFIRM_REQUEST,
  payload,
});

export const transferRequestReset = () => ({
  type: Constants.MANAGE_USER_TRANSFER_REQUEST_RESET,
});

export const addUserDetails = (payload: any) => ({
  type: Constants.MANAGE_USER_ADD,
  payload,
});
export const addUserDetailsSuccess = (payload: any) => ({
  type: Constants.MANAGE_USER_ADD_SUCCESS,
  payload,
});

export const editUserDetails = (payload: any) => ({
  type: Constants.MANAGE_USER_EDIT,
  payload,
});
export const editUserDetailsSuccess = (payload: any) => ({
  type: Constants.MANAGE_USER_EDIT_SUCCESS,
  payload,
});

export const removeUserDetails = (payload: any) => ({
  type: Constants.MANAGE_USER_REMOVE,
  payload,
});
export const removeUserDetailsSuccess = (payload: any) => ({
  type: Constants.MANAGE_USER_REMOVE_SUCCESS,
  payload,
});

export const resetLoadedStatus = () => ({
  type: Constants.MANAGE_USER_LOADED_RESET,
});

export const getCapacityList = (payload: any) => ({
  type: Constants.GET_MANAGE_CAPACITY_LIST,
  payload,
});

export const getCapacityListWithCount = (payload: any) => ({
    type: Constants.GET_MANAGE_CAPACITY_LIST_WITH_COUNT,
    payload,
  });

export const capacityListSuccess = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_LIST_SUCCESS,
  payload,
});

export const getCapacityLoads = (payload: any) => ({
    type: Constants.GET_CAPACITY_LOADS,
    payload,
});

export const getCapacityLoadsSuccess = (payload: any) => ({
  type: Constants.GET_CAPACITY_LOADS_SUCCESS,
  payload,
});

export const setCapacityFilter = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_FILTER,
  payload,
});

export const addManageCapacity = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_ADD,
  payload,
});

export const setSelectedCapacity = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_SELECTED,
  payload,
});

export const manageCapacityAddSuccess = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_ADD_SUCCESS,
  payload,
});

export const removeManageCapacity = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_REMOVE,
  payload,
});

export const manageCapacityRemoveSuccess = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_REMOVE_SUCCESS,
  payload,
});

export const updateManageCapacity = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_EDIT,
  payload,
});

export const manageCapacityUpdateSuccess = (payload: any) => ({
  type: Constants.MANAGE_CAPACITY_EDIT_SUCCESS,
  payload,
});

export const loadCarrierData = (payload: any) => ({
  type: Constants.CARRIER_MANAGE_DATA_REQUEST,
  payload,
});

export const carrierDataSuccess = (payload: any) => ({
  type: Constants.CARRIER_MANAGE_DATA_SUCCESS,
  payload,
});

export const carrierDataFailure = (payload: any) => ({
  type: Constants.CARRIER_MANAGE_DATA_FAILURE,
  payload,
});

export const setCapacityToSeeResult = (payload: any) => ({
  type: Constants.SET_CAPACITY_TO_SEE_RESULT,
  payload,
});

export const getCountryStateCodes = () => {
  return {
    type: Constants.GET_STATE_COUNTRY_CODES,
  };
};

export const loadStateCountryCodes = (payload: any, isLoading: boolean) => {
  return {
    type: Constants.LOAD_STATE_COUNTRY_CODES,
    payload: {
      response: payload,
      isLoading,
    },
  };
};
export const removeManageCapacityLoadsResults = (payload: any) => ({
  type: Constants.REMOVE_MANAGE_CAPACITY_LOADS_RESULTS,
  payload,
});
export const usrDeletionRequest= (payload: any) => ({
  type: Constants.USER_DELETION_REQUEST,
  payload,
});

export const reSendInvite = (data:any) => ({
  type: Constants.RESEND_INVITE,
  payload: data,
});

export const setManageSegmentSelected= (payload: any) => ({
  type: Constants.STORE_SEGMENT_SELECTED,
  payload,
});